"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditNoteUploadModal = CreditNoteUploadModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var credit_note_1 = require("../../../features/apis/credit-note");
var money = function (n) { return "R ".concat((n !== null && n !== void 0 ? n : 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })); };
// IF-004.3.2 Step 2: attach the (externally-generated) credit-note PDFs. A PDF can be dropped on a
// single cost-item total, or on the whole tenant-area-month (fans out to all its cost items).
function CreditNoteUploadModal(_a) {
    var _this = this;
    var isOpen = _a.isOpen, onClose = _a.onClose, creditNotes = _a.creditNotes, performedBy = _a.performedBy, tenantNameById = _a.tenantNameById, areaNameById = _a.areaNameById, formatPeriodLabel = _a.formatPeriodLabel, onChanged = _a.onChanged;
    var uploadPdf = (0, credit_note_1.useUploadCreditNotePdfMutation)()[0];
    var removePdf = (0, credit_note_1.useRemoveCreditNotePdfMutation)()[0];
    var fetchUrl = (0, credit_note_1.useLazyFetchCreditNotePdfUrlQuery)()[0];
    var _b = (0, react_3.useState)(null), dragTarget = _b[0], setDragTarget = _b[1];
    var _c = (0, react_3.useState)(null), busyId = _c[0], setBusyId = _c[1];
    var fileInputRef = (0, react_3.useRef)(null);
    var pendingTarget = (0, react_3.useRef)(null);
    // Group by tenant · area · month.
    var groups = (0, react_3.useMemo)(function () {
        var m = new Map();
        for (var _i = 0, creditNotes_1 = creditNotes; _i < creditNotes_1.length; _i++) {
            var cn = creditNotes_1[_i];
            var key = "".concat(cn.tenantId, "|").concat(cn.areaId, "|").concat(cn.billingPeriod);
            var g = m.get(key);
            if (!g) {
                g = { tenantId: cn.tenantId, areaId: cn.areaId, billingPeriod: cn.billingPeriod, notes: [] };
                m.set(key, g);
            }
            g.notes.push(cn);
        }
        return Array.from(m.values());
    }, [creditNotes]);
    var doUpload = function (creditNoteId, file, whole) { return __awaiter(_this, void 0, void 0, function () {
        var fd, err_1, data;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (file.type !== "application/pdf") {
                        (0, react_1.addToast)({ title: "PDF required", description: "Credit notes must be PDF files.", color: "danger" });
                        return [2 /*return*/];
                    }
                    setBusyId(creditNoteId);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    fd = new FormData();
                    fd.append("document", file);
                    if (performedBy)
                        fd.append("performedBy", performedBy);
                    if (whole)
                        fd.append("applyToWholeInvoice", "true");
                    return [4 /*yield*/, uploadPdf({ creditNoteId: creditNoteId, formData: fd }).unwrap()];
                case 2:
                    _c.sent();
                    (0, react_1.addToast)({ title: whole ? "Credit note applied to all cost items" : "Credit note attached", color: "success" });
                    onChanged();
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _c.sent();
                    data = err_1 === null || err_1 === void 0 ? void 0 : err_1.data;
                    if (data === null || data === void 0 ? void 0 : data.clash) {
                        (0, react_1.addToast)({
                            title: "This PDF is already used elsewhere",
                            description: "".concat(data.message, " (clashes with ").concat((_a = data.clash.costItem) !== null && _a !== void 0 ? _a : "another total", " \u00B7 ").concat(data.clash.billingPeriod, ")."),
                            color: "warning",
                            timeout: 6000,
                        });
                    }
                    else {
                        (0, react_1.addToast)({ title: "Upload failed", description: (_b = data === null || data === void 0 ? void 0 : data.message) !== null && _b !== void 0 ? _b : "Could not attach the credit note.", color: "danger" });
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setBusyId(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var openPicker = function (creditNoteId, whole) {
        var _a;
        pendingTarget.current = { creditNoteId: creditNoteId, whole: whole };
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var onView = function (creditNoteId) { return __awaiter(_this, void 0, void 0, function () {
        var res, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchUrl(creditNoteId).unwrap()];
                case 1:
                    res = _c.sent();
                    if ((_b = res === null || res === void 0 ? void 0 : res.content) === null || _b === void 0 ? void 0 : _b.url)
                        window.open(res.content.url, "_blank", "noopener");
                    return [3 /*break*/, 3];
                case 2:
                    _a = _c.sent();
                    (0, react_1.addToast)({ title: "Could not open the credit note", color: "danger" });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onRemove = function (creditNoteId) { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setBusyId(creditNoteId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, removePdf({ creditNoteId: creditNoteId, performedBy: performedBy }).unwrap()];
                case 2:
                    _b.sent();
                    (0, react_1.addToast)({ title: "Credit note removed", color: "default" });
                    onChanged();
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    (0, react_1.addToast)({ title: "Could not remove the credit note", color: "danger" });
                    return [3 /*break*/, 5];
                case 4:
                    setBusyId(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var dropHandlers = function (creditNoteId, whole) { return ({
        onDragOver: function (e) {
            e.preventDefault();
            setDragTarget(creditNoteId + (whole ? ":whole" : ""));
        },
        onDragLeave: function () { return setDragTarget(null); },
        onDrop: function (e) {
            var _a;
            e.preventDefault();
            setDragTarget(null);
            var file = (_a = e.dataTransfer.files) === null || _a === void 0 ? void 0 : _a[0];
            if (file)
                doUpload(creditNoteId, file, whole);
        },
    }); };
    var totalGroups = groups.length;
    var pendingGroups = groups.filter(function (g) { return g.notes.some(function (n) { return !n.fileKey; }); }).length;
    // `disableAnimation` is load-bearing, not cosmetic. Animated HeroUI overlays never become visible
    // in this app — the modal mounts (focus scope + `aria-hidden` on #app + scroll lock all apply) but
    // its content stays at the animation's initial opacity, so the trigger button looks inert. Every
    // working modal and ~all 186 <Select>s in the codebase carry this prop for the same reason.
    // The z-index override keeps it above the fixed z-50 sidebar, matching the other analysis modals.
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onClose: onClose, size: "3xl", scrollBehavior: "inside", disableAnimation: true, classNames: { wrapper: "p-4 z-[70]", backdrop: "z-[69]" }, children: (0, jsx_runtime_1.jsxs)(react_1.ModalContent, { children: [(0, jsx_runtime_1.jsxs)(react_1.ModalHeader, { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-base font-semibold", children: "Upload Related Credit Notes" }), (0, jsx_runtime_1.jsxs)("span", { className: "text-xs font-normal text-gray-500", children: ["Drag a PDF onto a cost-item total, or onto the tenant total to apply it to every cost item. ", totalGroups - pendingGroups, "/", totalGroups, " ", "tenant-area-months complete."] })] }), (0, jsx_runtime_1.jsxs)(react_1.ModalBody, { children: [(0, jsx_runtime_1.jsx)("input", { ref: fileInputRef, type: "file", accept: "application/pdf", className: "hidden", onChange: function (e) {
                                var _a;
                                var file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                                e.target.value = "";
                                var t = pendingTarget.current;
                                if (file && t)
                                    doUpload(t.creditNoteId, file, t.whole);
                            } }), (0, jsx_runtime_1.jsxs)(react_1.ScrollShadow, { className: "flex max-h-[60vh] flex-col gap-4", children: [groups.map(function (g) {
                                    var _a;
                                    var label = "".concat(areaNameById[g.areaId] || "Building", " \u00B7 ").concat(tenantNameById[g.tenantId] || g.tenantId);
                                    var groupTotal = g.notes.reduce(function (s, n) { return s + (n.totalVatExcl || 0); }, 0);
                                    // Any pending cost-item note can host the "whole tenant-area-month" upload.
                                    var wholeTarget = (_a = g.notes.find(function (n) { return !n.fileKey; })) !== null && _a !== void 0 ? _a : g.notes[0];
                                    var allDone = g.notes.every(function (n) { return n.fileKey; });
                                    return ((0, jsx_runtime_1.jsxs)("div", { className: "rounded-lg border border-gray-200 p-3", children: [(0, jsx_runtime_1.jsxs)("div", { className: "mb-2 flex items-center justify-between gap-2", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)("span", { className: "text-sm font-semibold text-gray-800", children: label }), (0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "flat", color: allDone ? "success" : "warning", children: formatPeriodLabel(g.billingPeriod) })] }), (0, jsx_runtime_1.jsx)("span", { className: "font-mono text-xs text-gray-600", children: money(groupTotal) })] }), !allDone && ((0, jsx_runtime_1.jsxs)("div", __assign({}, dropHandlers(wholeTarget._id, true), { className: "mb-2 flex cursor-pointer items-center justify-center gap-2 rounded-md border-2 border-dashed px-3 py-2 text-xs ".concat(dragTarget === wholeTarget._id + ":whole" ? "border-primary bg-primary/5 text-primary" : "border-gray-300 text-gray-500"), onClick: function () { return openPicker(wholeTarget._id, true); }, children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:upload-square-linear", className: "text-base" }), "Drop / click: one PDF for the whole tenant total"] }))), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-1.5", children: g.notes.map(function (cn) {
                                                    var done = !!cn.fileKey;
                                                    var isBusy = busyId === cn._id;
                                                    var active = dragTarget === cn._id;
                                                    return ((0, jsx_runtime_1.jsxs)("div", __assign({}, dropHandlers(cn._id, false), { className: "flex items-center gap-2 rounded-md border px-2 py-1.5 text-xs ".concat(done ? "border-success-300 bg-success-50" : active ? "border-primary bg-primary/5" : "border-primary-200 bg-primary-50/40"), children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: done ? "solar:check-circle-bold" : "solar:upload-linear", className: done ? "text-success-600" : "text-primary" }), (0, jsx_runtime_1.jsx)("span", { className: "font-medium ".concat(done ? "text-success-800" : "text-primary-700"), children: cn.costItem || "Charges" }), (0, jsx_runtime_1.jsx)("span", { className: "font-mono text-gray-600", children: money(cn.totalVatExcl) }), done && cn.fileName && (0, jsx_runtime_1.jsxs)("span", { className: "truncate text-gray-500", children: ["\u00B7 ", cn.fileName] }), (0, jsx_runtime_1.jsx)("div", { className: "ml-auto flex items-center gap-1", children: !done ? ((0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "primary", isLoading: isBusy, onPress: function () { return openPicker(cn._id, false); }, children: "Upload" })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", isIconOnly: true, onPress: function () { return onView(cn._id); }, "aria-label": "View credit note", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:eye-linear", className: "text-sm" }) }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "danger", isIconOnly: true, isLoading: isBusy, onPress: function () { return onRemove(cn._id); }, "aria-label": "Remove credit note", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:close-circle-linear", className: "text-sm" }) })] })) })] }), cn._id));
                                                }) })] }, "".concat(g.tenantId, "|").concat(g.areaId, "|").concat(g.billingPeriod)));
                                }), groups.length === 0 && (0, jsx_runtime_1.jsx)("span", { className: "py-6 text-center text-sm text-gray-400", children: "No credit notes to upload." })] })] }), (0, jsx_runtime_1.jsxs)(react_1.ModalFooter, { children: [(0, jsx_runtime_1.jsx)(react_1.Divider, { className: "mb-2" }), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "light", onPress: onClose, children: "Done" })] })] }) }));
}
